// src/components/FoundGathering.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";  // for the celebration effect
import memberstackDOM from "@memberstack/dom";
import "../css/okgather1.webflow.css"; // Using the same styles as Slots.js (plus the spinner CSS)
import { getMemberstackKey } from "../utils";

const currentKey = getMemberstackKey();
const memberstack = memberstackDOM.init({
  publicKey: currentKey,
});

const FoundGathering = () => {
  const navigate = useNavigate();

  const [progress, setProgress] = useState(0);
  const [statusMessage, setStatusMessage] = useState("Getting things ready...");
  const [isComplete, setIsComplete] = useState(false);

  const statusUpdates = [
    "Creating your account...",
    "Checking available dates...",
    "Almost there...",
    "Almost done..."
  ];

  // Increment progress every 3 seconds.
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 25;
        if (next >= 100) {
          clearInterval(interval);
          setIsComplete(true);
          return 100;
        }
        return next;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Update status message based on progress.
  useEffect(() => {
    if (progress < 25) setStatusMessage(statusUpdates[0]);
    else if (progress < 50) setStatusMessage(statusUpdates[1]);
    else if (progress < 75) setStatusMessage(statusUpdates[2]);
    else if (progress < 100) setStatusMessage(statusUpdates[3]);
  }, [progress]);

  // Trigger confetti when complete.
  useEffect(() => {
    if (isComplete) {
      confetti({
        particleCount: 160,
        spread: 100,
        origin: { y: 0.6 },
      });
    }
  }, [isComplete]);

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("memberstackToken");
      if (!token) {
        alert("No token found. Please log in.");
        return;
      }

      const response = await memberstack.getCurrentMember();
      let hasActivePaidSubscription = false;
      for (const plan of response.data.planConnections) {
        if (plan.status === "ACTIVE" && plan.type === "SUBSCRIPTION") {
          hasActivePaidSubscription = true;
          break;
        }
      }

      if (hasActivePaidSubscription) {
        navigate("/my-events");
      } else {
        navigate("/checkout");
      }
    } catch (error) {
      console.error("Error during membership check:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="page-wrapper">
      <main className="main-wrapper">
        <section className="section_hero">
          <div className="padding-global padding-section-large container-large">
            <div className="hero_card is-vertical">
              {!isComplete ? (
                <>
                  <h2 style={{ textAlign: "center", marginBottom: "24px" }}>
                    Getting you set up...
                  </h2>

                  {/* Simple spinner instead of a GIF */}
                  <div className="spinner" />

                  {/* Progress bar */}
                  <div
                    className="progress-bar"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      overflow: "hidden",
                      margin: "20px auto",
                      width: "80%",
                      maxWidth: "500px",
                    }}
                  >
                    <div
                      style={{
                        height: "20px",
                        width: `${progress}%`,
                        background: "#4caf50",
                        transition: "width 1s ease",
                      }}
                    ></div>
                  </div>

                  {/* Status message in bold */}
                  <p style={{ textAlign: "center", fontWeight: "bold" }}>
                    {statusMessage}
                  </p>
                </>
              ) : (
                <>
                  <h2 style={{ textAlign: "center", marginBottom: "24px" }}>You'll be joining us soon!</h2>
                  <p style={{ textAlign: "center" }}>
                    Thanks for signing up. You're on the waiting list for the moment but we'll let you know as soon as we open things up! 
                  </p>
                </>
              )}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoundGathering;
